import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import React from "react";
import MenuMobil from "./MenuMobil";
const Logo = ({ anim, showMenu }) => {
  const location = useLocation();

  useEffect(() => {
    if (anim) {
      const anim_slider = document.querySelector(".logo_container");
      anim_slider.classList.remove("animate__bounceInDown");
      anim_slider.classList.add("animate__bounceOutDown");
    }
  }, [anim]);

  return (
    <div className="logo">
      <div className="container_hamburger">
        <img
          loading="lazy"
          onClick={showMenu}
          className="hamburger"
          src="/assets/menu.png"
          alt="hangover"
        />
      </div>

      <MenuMobil showMenu={showMenu} />
      <div className="max_w">
        {location.pathname === "/selecciona-audio-dos" ||
        location.pathname === "/textos-video-dos" ||
        location.pathname === "/render-video-dos" ||
        location.pathname === "/galeria" ||
        location.pathname === "/formulario" ? (
          <div className="logo_container ">
            <div className="content_logo">
              <img
                loading="lazy"
                onClick={() => (window.location.href = "https://cantirondas.com/")}
                src="/assets/logo.png"
                alt=""
              />
            </div>
          </div>
        ) : location.pathname === "/nombre" ? (
          <div className="logo_container animate__animated animate__bounceInRight">
            <div className="content_logo">
              <img
                loading="lazy"
                onClick={() => (window.location.href = "https://cantirondas.com/")}
                src="/assets/logo.png"
                alt=""
              />
            </div>
          </div>
        ) : (
          <div className="logo_container home_logo animate__animated animate__bounceInDown">
            <div className="content_logo">
              <img
                loading="lazy"
                onClick={() => (window.location.href = "https://cantirondas.com/")}
                src="/assets/logo.png"
                alt=""
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Logo;
